export default "__VITE_ASSET__gM$saVHq__"